import * as types from '../mutation-types.js'
import {
  query
} from '../../js/util.urlSearch.js'
// initial state
const state = {
    fromSource: query('from')||'', // cvip 来源
    cvipMes: '',
    getinsurance: '', //会员状态    老版会员  || 新版会员
    getAccidentInsuranceState: '', //投保状态
    leftTop: 0,   // 剩余天数
    loginIs: false,
    userInfo: {
        nickname: '',
        profile: ''
    },            // 用户信息
    rightUsed: {
        4: false,
        5: false,
        10: false,
        11: false,
        12: false,
        13: false,
        14: false,
        15: false
    }, // 特权使用情况
    resumeListNum: 0,   // 简历数量
    mealInfo: '',           //套餐名称
    renew: false
}

// getters
const getters = {
    fromSource: state => state.fromSource,
    cvipMes: state => state.cvipMes,
    getinsurance: state => state.getinsurance,  //会员状态   老版会员  || 新版会员
    getAccidentInsuranceState: state => state.getAccidentInsuranceState,   //投保状态
    leftTop: state => state.leftTop,
    loginIs: state => state.loginIs,
    userInfo: state => state.userInfo,
    rightUsed: state => state.rightUsed,
    resumeListNum: state => state.resumeListNum,
    mealInfo: state => state.mealInfo
}

// actions
const actions = {}

// mutations
const mutations = {
    [types.CHANGE_CVIP_FROM](state, payload) {
            state.fromSource = payload.state;
        },
    [types.CHANGE_CVIP_MES](state, payload) {
        state.cvipMes = payload.state
    },
    CVIP_STATE(state, data){
        state.getinsurance = data;
    },
    INSURANCE_STATE(state, data){ //会员状态   老版会员  || 新版会员
        state.getAccidentInsuranceState = data.entity;
    },
    IS_LOGIN(state, data) {
        state.loginIs = data
    },
    LEFT_TOP(state, data) {
        state.leftTop = data
    },
    USER_INFO(state, data) {
        state.userInfo = Object.assign(state.userInfo, data)
    },
    RIGHT_USED(state, data) {
        state.rightUsed = Object.assign(state.rightUsed, data)
    },
    RESUME_NUM(state, data) {
        state.resumeListNum = data
    },
    RENEW_STATE(state, data){   // 是否为续费状态
        state.renew = data;
    },
    MEAL_INFO(state, data) {
        state.mealInfo = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js